import { checkinApi } from '@/services/api/httpClient';

const docuSignActions = {
  async getDocuSignUrl({ state, rootState }, { redirectUrl }) {
    const { id, admissionDate, visit, cip, unitId, urlMedicalOrders, payments } =
      rootState.currentAdmission.data;
    const { name: patientName, id: mdmId, contacts } = rootState.mdm.data;
    const brandId = rootState.brandUnit.data.currentBrand.brandId;

    let finalMail = '';

    const principalEmail = contacts.find(
      (contact) => contact.contactType === 'EMAIL' && contact.principal,
    );

    if (principalEmail) {
      finalMail = principalEmail.value;
    } else {
      finalMail = contacts.find((contact) => contact.contactType === 'EMAIL').value || '';
    }

    const url = '/cross/docusign';
    try {
      const resp = await checkinApi().post(url, {
        admissionId: id,
        admissionDate,
        unitId: String(unitId),
        brandId: String(brandId),
        cip: String(cip),
        visit: String(visit),
        patient: {
          mdmId: String(mdmId),
          name: patientName,
          email: finalMail,
        },
        payment: {
          clientId: payments && payments.length && Number(payments[0].clientId),
        },
        urlMedicalOrders,
        redirectUrl,
      });
      return resp.data;
    } catch (error) {
      console.error('Erro ao bater na API de assinatura ', error);
      return null;
    }
  },
};

export default docuSignActions;
